import { completeLoadingState } from '@/entities/userInterface/slices/loaderSlice'
import { createAsyncThunk } from '@reduxjs/toolkit'

// This asynchronous function is designed to initialize and set up global state in the Redux store related to the operations planning page.
export const setupSubscription = createAsyncThunk('subscription/setup', async (_, { dispatch }) => {
  dispatch(completeLoadingState())
})